'use client'

import {observer} from 'mobx-react'

import * as UIDetail from '@/src/entities/news/ui/detail.styled'

import {NewsDetailContent} from '@/src/features/news-articles'

import noPhotoPic from '@/src/shared/assets/media/no-photo.png'
import {useStore} from '@/src/shared/hooks/useStore'
import {Image} from '@/src/shared/ui/image'
import React from 'react'

export const NewsDetailContentContainer = observer(
  ({suspense}: {suspense: {content: React.ReactNode}}) => {
    const {pageData} = useStore<NewsDetailContent>()
    const content = pageData!.content

    const {news} = content

    return (
      <UIDetail.Article>
        <UIDetail.H1>{content.news.title}</UIDetail.H1>
        <div>{content.news.date_create}</div>

        {news?.cover && news.cover.src && (
          <UIDetail.Image>
            <Image
              src={(news.cover.type === 'image' && `${news.cover.src}`) || noPhotoPic}
              alt={news.title}
              width={603}
              height={401}
            />
          </UIDetail.Image>
        )}

        {suspense.content && <UIDetail.Content>{suspense.content}</UIDetail.Content>}
      </UIDetail.Article>
    )
  },
)
